import { render, staticRenderFns } from "./HkFooter.vue?vue&type=template&id=70d31ce1&scoped=true&"
import script from "./HkFooter.vue?vue&type=script&lang=js&"
export * from "./HkFooter.vue?vue&type=script&lang=js&"
import style0 from "./HkFooter.vue?vue&type=style&index=0&id=70d31ce1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d31ce1",
  null
  
)

export default component.exports